/*
 * Desktop path → XP icon PNG mapping.
 *
 * Source: public/xp/icons/ (vendored from Cyanoxide/react-xp, MIT).
 * Add a row here when a new desktop window is registered; the file lives
 * at `/xp/icons/${file}` once Vite serves the public/ directory.
 *
 * Falling back to a generic shortcut icon means a misconfigured path
 * still renders something — better than a broken image.
 */

export const XP_ICON_FALLBACK = '/xp/icons/icon__shortcut.png';

export const XP_DESKTOP_ICONS: Record<string, string> = {
  '/documents': '/xp/icons/icon__file_explorer--large.png',
  '/prompt-lab': '/xp/icons/icon__notepad--large.png',
  '/clients': '/xp/icons/icon__network_places--large.png',
  '/skills': '/xp/icons/icon__documents--large.png',
  '/corpus-search': '/xp/icons/icon__search--large.png',
  // L.7 — Specialization Lab — borrow the bases (spreadsheet/table) icon
  // since we don't have a dedicated "lab" SVG yet; the desktop label
  // ("🧠 Specialization Lab") carries the metaphor.
  '/specialization-lab': '/xp/icons/icon__bases--large.svg',
  '/settings': '/xp/icons/icon__control_panel--large.png',
  // icon__info.png is the 16x16 thumbnail and pixelates hard at the
  // 48x48 desktop size. Replaced with a hand-authored XP-style yellow
  // book + blue question-mark SVG that scales cleanly.
  '/help': '/xp/icons/icon__help--large.svg',
  '/admin/portals/new': '/xp/icons/icon__new_folder--large.png',
  '/admin/schema-profiles': '/xp/icons/icon__publish_web--large.png',
  // J.3 — opt-in "Create my private workspace". Uses the large
  // computer icon (private personal workspace metaphor).
  '/admin/workspace-setup': '/xp/icons/icon__computer--large.png',
  // F18 — customer-facing portal provisioning wizard. "Network Places"
  // icon evokes setting up a connection to an external SharePoint.
  '/onboard/new': '/xp/icons/icon__network_places--large.png',
  '/obsidian-import': '/xp/icons/icon__share_folder--large.png',
  '/obsidian-vault': '/xp/icons/icon__hdd--large.png',
  // Vault Graph: XYFlow-style network diagram (concept nodes + edges).
  '/vault-graph': '/xp/icons/icon__graph--large.svg',
  // Bases: saved Dataview tables — render as a green-header spreadsheet.
  '/bases': '/xp/icons/icon__bases--large.svg',
  '/vault-flow': '/xp/icons/icon__pictures.png',
  '/profile': '/xp/icons/icon__computer.png',
};

export function getXpIcon(path: string): string {
  return XP_DESKTOP_ICONS[path] ?? XP_ICON_FALLBACK;
}
